import { render, staticRenderFns } from "./LearningReport.vue?vue&type=template&id=bec7f50a&scoped=true"
import script from "./LearningReport.vue?vue&type=script&lang=js"
export * from "./LearningReport.vue?vue&type=script&lang=js"
import style0 from "./LearningReport.vue?vue&type=style&index=0&id=bec7f50a&prod&scoped=true&lang=css"
import style1 from "./LearningReport.vue?vue&type=style&index=1&id=bec7f50a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec7f50a",
  null
  
)

export default component.exports